module.exports = __webpack_public_path__ + "static/media/anchors_signup.61a5903d.gif";